import React, { useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import "./App.css";

const socket = io("https://chat-app-ltpf.onrender.com");

function App() {
  const [username, setUsername] = useState("");
  const [room, setRoom] = useState("");
  const [joined, setJoined] = useState(false);

  const [msg, setMsg] = useState("");
  const [chat, setChat] = useState([]);

  const chatEndRef = useRef(null);

  // Join room
  const joinRoom = () => {
    if (username && room) {
      socket.emit("join_room", room);
      setJoined(true);
    }
  };

  // Send message
  const sendMsg = () => {
    if (msg !== "") {
      const messageData = {
        room,
        author: username,
        message: msg,
        time: new Date().toLocaleTimeString(),
      };

      socket.emit("send_message", messageData);
      setChat((prev) => [...prev, messageData]);
      setMsg("");
    }
  };

  // Receive message
  useEffect(() => {
    socket.on("receive_message", (data) => {
      setChat((prev) => [...prev, data]);
    });

    return () => socket.off("receive_message");
  }, []);

  // Auto scroll
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat]);

  return (
    <div className="container">
      {!joined ? (
        <div>
          <h2>Join Chat</h2>

          <input
            placeholder="Username"
            onChange={(e) => setUsername(e.target.value)}
          />
          <br /><br />

          <input
            placeholder="Room ID"
            onChange={(e) => setRoom(e.target.value)}
          />
          <br /><br />

          <button onClick={joinRoom}>Join</button>
        </div>
      ) : (
        <div className="chat-box">
          <div className="chat-header">Room: {room}</div>

          <div className="chat-body">
            {chat.map((c, i) => (
              <div
                key={i}
                className={`message ${
                  c.author === username ? "me" : "other"
                }`}
              >
                <div className="bubble">
                  <strong>{c.author}</strong><br />
                  {c.message}
                  <div className="time">{c.time}</div>
                </div>
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>

          <div className="chat-footer">
            <input
              value={msg}
              placeholder="Message..."
              onChange={(e) => setMsg(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && sendMsg()}
            />
            <button onClick={sendMsg}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;